import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import css from './Modals.module.css';
import useLocales from '../../../hooks/useLocales';
import TextWithIcon from '../Labels/TextWithIcon';
import ImgBox from '../Box/ImgBox';
import Iconify from '../../Iconify';

// import Carrousel from '../Carrousel/Carrousel';

// import img1 from '../../../assets/images/tempImg/bojnickyhrad.png';
// import img2 from '../../../assets/images/tempImg/mohyla.jpg';
// import img3 from '../../../assets/images/tempImg/studna.png';

ModalObjectFullscreen.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  items: PropTypes.array,
  startIdx: PropTypes.number,
};

export default function ModalObjectFullscreen({ open, onClose, items, startIdx = 0 }) {
  const navigate = useNavigate({ to: '' });
  const [ind, setInd] = useState(startIdx);
  const theme = useTheme();
  useEffect(() => {
    setInd(startIdx);
  }, [startIdx]);
  const { translate } = useLocales();
  // const images = [
  //   { img: img1, label: '' },
  //   { img: img2, label: '' },
  //   { img: img3, label: '' },
  //   { img: img2, label: '' },
  //   { img: img1, label: '' },
  //   { img: img3, label: '' },
  // ];

  const pathCatalogue = window.location.pathname.includes('en/')
    ? `/en${translate('urls.coId')}`
    : translate('urls.coId');

  const pathArticles = window.location.pathname.includes('en/')
    ? `/en${translate('urls.articlesId')}`
    : translate('urls.articlesId');

  const pathSheets = window.location.pathname.includes('en/')
    ? `/en${translate('urls.sheetsId')}`
    : translate('urls.sheetsId');

  const pathInst = window.location.pathname.includes('en/')
    ? `/en${translate('urls.institutionsId')}`
    : translate('urls.institutionsId');

  // eslint-disable-next-line consistent-return
  const getURl = () => {
    let index;
    switch (items[ind].type) {
      case 'sheet':
        return navigate(`${pathSheets.replace(':id', items[ind].key)}?fromPage=fav`);
      case 'article':
        if (items[ind].url.includes('http')) {
          window.open(items[ind].url, '_self', 'noopener,noreferrer');
        } else navigate(`${pathArticles.replace(':id', items[ind].key)}?fromPage=fav`);
        return null;
      case 'edu':
        index = window.location.href.indexOf('/');
        // eslint-disable-next-line no-alert
        if (items[ind].url === '') {
          // eslint-disable-next-line no-alert
          alert('url is blank');
        } else if (!items[ind].url.includes('http')) {
          if (window.location.pathname.includes('en/')) {
            window.open(
              `${
                window.location.href.slice(0, index + 2) +
                items[ind].url.replace('kulturne-objekty', 'en/edu-materials')
              }?fromPage=fav`,
              '_self',
              'noopener,noreferrer'
            );
          } else {
            window.open(
              `${
                window.location.href.slice(0, index + 2) + items[ind].url.replace('kulturne-objekty', 'edu-materialy')
              }?fromPage=fav`,
              '_self',
              'noopener,noreferrer'
            );
          }
        } else if (window.location.pathname.includes('en/')) {
          window.open(
            `${items[ind].url.replace('kulturne-objekty', 'en/edu-materials')}?fromPage=fav`,
            '_self',
            'noopener,noreferrer'
          );
        } else {
          window.open(
            `${items[ind].url.replace('kulturne-objekty', 'edu-materialy')}?fromPage=fav`,
            '_self',
            'noopener,noreferrer'
          );
        }

        break;
      case 'multimedia':
        index = window.location.href.indexOf('/');
        // eslint-disable-next-line no-alert
        if (items[ind].url === '') {
          // eslint-disable-next-line no-alert
          alert('url is blank');
        } else if (!items[ind].url.includes('http')) {
          if (window.location.pathname.includes('en/')) {
            window.open(
              `${
                window.location.href.slice(0, index + 2) + items[ind].url.replace('kulturne-objekty', 'en/videogallery')
              }?fromPage=fav`,
              '_self',
              'noopener,noreferrer'
            );
          } else {
            window.open(
              `${
                window.location.href.slice(0, index + 2) + items[ind].url.replace('kulturne-objekty', 'videoteka')
              }?fromPage=fav`,
              '_self',
              'noopener,noreferrer'
            );
          }
        } else if (window.location.pathname.includes('en/')) {
          window.open(
            `${items[ind].url.replace('kulturne-objekty', 'en/videogallery')}?fromPage=fav`,
            '_self',
            'noopener,noreferrer'
          );
        } else {
          window.open(
            `${items[ind].url.replace('kulturne-objekty', 'videoteka')}?fromPage=fav`,
            '_self',
            'noopener,noreferrer'
          );
        }
        break;
      case 'object':
        return navigate(`${pathCatalogue.replace(':id', items[ind].key)}?fromPage=fav`);
      case 'trip':
        return navigate(`${pathInst.replace(':id', items[ind].key)}?fromPage=fav`);
      default:
        break;
    }
    // return null
  };

  /*  const otherImg = (
    <Grid container sx={{ overflowY: 'hidden', height: '58vh', display: 'block' }}>
      {items.map((item, idx) => (
        <Grid key={idx} xs={12} item sx={{ position: 'relative', margin: '0px 4px 12px 0px' }}>
          <Box
            className="border-radius-6"
            img={item.img}
            sx={{ minWidth: '100%', height: '120px', objectFit: 'cover' }}
          />
        </Grid>
      ))}
    </Grid>
  );  */

  const nextObject = () => {
    if (ind !== items.length - 1) setInd(ind + 1);
  };
  const prevObect = () => {
    if (ind !== 0) setInd(ind - 1);
  };

  const getIMG = () => {
    if ('thumbnail' in items[ind]) {
      if (items[ind].thumbnail.includes('http')) return items[ind].thumbnail;
      return items[ind].thumbnail !== undefined && items[ind].thumbnail !== ''
        ? `${process.env.REACT_APP_API_URL}/image/download/${items[ind].thumbnail}?sizeIndex=0`
        : '';
    }
    if ('thumbnailImageId' in items[ind]) {
      return items[ind].thumbnailImageId !== undefined && items[ind].thumbnailImageId !== ''
        ? `${process.env.REACT_APP_API_URL}/image/download/${items[ind].thumbnailImageId}?sizeIndex=0`
        : '';
    }
    if ('img' in items[ind]) {
      return items[ind].img;
    }
    return null;
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        /* sx={style}  */ sx={{ backgroundColor: theme.palette.background.paper }}
        className={`${css.modalLightBox}`}
      >
        <Typography variant="body2" className={css.closeIcon} sx={{ color: 'white' }} onClick={onClose}>
          <Iconify icon="fa:close" />
        </Typography>
        <Box>
          <Grid container justifyContent="center" alignItems="center">
            <ImgBox
              // TODO - unite naming of images
              src={getIMG()}
              sx={{ width: '100%', maxHeight: '90vh', objectFit: 'contain !important', backgroundColor: 'black' }}
            />
            <Iconify className={`${css.imgArrow} ${css.imgArrowLeft}`} onClick={prevObect} icon="fa:chevron-left" />
            <Iconify
              className={`${css.imgArrow} ${css.imgArrowRight}`}
              onClick={nextObject}
              icon="fa:chevron-right"
            />{' '}
            <Box
              className={css.imgCounter}
              sx={{ color: 'common.black', display: 'flex', alignItems: 'center', width: 'max-content' }}
            >
              <TextWithIcon text={ind + 1} action={prevObect} icon="fa:chevron-left" left spacing={12} />
              <span style={{ margin: '0px 6px 0px 6px' }}>/</span>
              <TextWithIcon text={`${items.length}`} action={nextObject} icon="fa:chevron-right" right spacing={12} />
            </Box>
            <Button
              size="small"
              variant="outlined"
              onClick={() => getURl()}
              sx={{
                position: 'absolute',
                bottom: '4%',
                right: '4%',
                padding: '8px 12px',
                minHeight: 'auto',
                background: (theme) => theme.palette.grey[100],
                border: `1px solid grey`,
                '&:hover': {
                  background: (theme) => theme.palette.grey[200],
                  border: `1px solid #464444`,
                },
              }}
            >
              {translate('default.showDetail')}
            </Button>
            {/* <Grid xs={12} item sx={{ margin: '24px 0px 24px 0px' }}>
              <Typography variant="h5" sx={{ textAlign: 'center' }}>
                {translate('Mohlo by ťa tiež zaujímať')}
              </Typography>
              <Carrousel images={images} height="18vh" withoutLabel />
            </Grid> */}
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
}
